import { render, staticRenderFns } from "./CompPublicNoticeViewer.vue?vue&type=template&id=12e85afa"
import script from "./CompPublicNoticeViewer.vue?vue&type=script&lang=js"
export * from "./CompPublicNoticeViewer.vue?vue&type=script&lang=js"
import style0 from "./CompPublicNoticeViewer.vue?vue&type=style&index=0&id=12e85afa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports